import React, { Fragment, Component } from 'react';
import moment from "moment";
import cx from 'classnames';
import { Link } from 'react-router-dom';

import { Nav, NavItem, NavLink } from 'reactstrap';

import { connect } from 'react-redux';

class Footer extends Component {
  render() {
    let { footerShadow, footerFixed, footerBgTransparent } = this.props;

    return (
      <Fragment>
        <div
          className={cx('app-footer text-black-50', {
            'app-footer--shadow': footerShadow,
            'app-footer--opacity-bg': footerBgTransparent
          })}>
          <div className="app-footer--first">
          </div>
          <div className="app-footer--second">
            <span>JobElephant</span> ©
            {moment().format('YYYY')}
            {" | "}
            <a href="https://jobelephant.com/w/wp-content/uploads/2024/10/CPortal-WCAG-2.1-VPAT_ACR_Statement_10_24.pdf" target="_blank" title="Voluntary Product Accessibility Template">
              Voluntary Product Accessibility Template (VPAT)
            </a>
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  footerFixed: state.ThemeOptions.footerFixed,
  footerShadow: state.ThemeOptions.footerShadow,
  footerBgTransparent: state.ThemeOptions.footerBgTransparent
});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Footer);
